(function () {
  'use strict';
  var scope = document.querySelector('[data-serene-collection]');
  var data = document.getElementById('SereneCollectionFacets');
  if (!scope || !data || scope.dataset.ready === 'true') return;
  scope.dataset.ready = 'true';
  var options = JSON.parse(data.textContent);
  var list = scope.querySelector('#product-grid');
  var cards = Array.from(list.querySelectorAll('[data-collection-product]'));
  var products = cards.map(function (card) {
    return { handle: card.dataset.handle, price: Number(card.dataset.price), card: card };
  });
  var groups = ['health', 'benefit', 'price'];
  var selected;
  var nativeSort = new URLSearchParams(location.search).get('sort_by') || scope.dataset.defaultSort || 'manual';
  function readSelection() {
    var params = new URLSearchParams(location.search);
    selected = {};
    groups.forEach(function (group) {
      selected[group] = params.getAll('serene_' + group).filter(function (value) {
        return options.some(function (option) { return option.group === group && option.value === value; });
      });
    });
  }
  function matches(product, state, omitGroup) {
    return groups.every(function (group) {
      if (group === omitGroup || !state[group].length) return true;
      return state[group].some(function (value) {
        var option = options.find(function (option) { return option.group === group && option.value === value; });
        if (!option) return false;
        if (group === 'price') return product.price >= option.min && (option.max === null || product.price < option.max);
        return option.handles.indexOf(product.handle) !== -1;
      });
    });
  }
  function currentUrl() {
    var url = new URL(location.href);
    groups.forEach(function (group) {
      url.searchParams.delete('serene_' + group);
      selected[group].forEach(function (value) { url.searchParams.append('serene_' + group, value); });
    });
    // Reproduced source IDs are never sent to the target store's native filters.
    Array.from(url.searchParams.keys()).forEach(function (key) {
      if (key.indexOf('filter.p.m.custom.') === 0) url.searchParams.delete(key);
    });
    url.searchParams.delete('page');
    return url;
  }
  function changeUrl() {
    var url = currentUrl();
    if (url.href !== location.href) history.pushState({}, '', url.pathname + url.search + url.hash);
  }
  function closeMobile() {
    var drawer = scope.querySelector('.mobile-facets__disclosure');
    if (!drawer) return;
    drawer.open = false;
    drawer.classList.remove('menu-opening');
    drawer.querySelector('summary')?.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('overflow-hidden-mobile', 'overflow-hidden-tablet', 'overflow-hidden');
  }
  function clearButton(text, className) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = className || 'active-facets__button-remove underlined-link';
    button.textContent = text;
    button.addEventListener('click', function () {
      groups.forEach(function (group) { selected[group] = []; });
      changeUrl();
      render();
    });
    return button;
  }
  var empty = document.createElement('div');
  empty.className = 'serene-collection-empty';
  empty.setAttribute('role', 'status');
  var emptyText = document.createElement('p');
  emptyText.textContent = 'No products match these filters.';
  empty.append(emptyText, clearButton('Clear filters'));
  list.after(empty);
  var activeContainers = Array.from(scope.querySelectorAll('.active-facets-desktop, .active-facets-mobile'));
  activeContainers.forEach(function (container) {
    var chips = document.createElement('div');
    chips.className = 'serene-active-filters';
    container.appendChild(chips);
  });
  function render() {
    var visible = products.filter(function (product) { return matches(product, selected); });
    products.forEach(function (product) { product.card.hidden = visible.indexOf(product) === -1; });
    var count = visible.length + (visible.length === 1 ? ' product' : ' products');
    scope.querySelectorAll('#ProductCount, #ProductCountDesktop, .mobile-facets__count').forEach(function (node) { node.textContent = count; });
    empty.hidden = visible.length > 0;
    scope.querySelectorAll('input[data-serene-facet]').forEach(function (input) {
      var group = input.dataset.sereneFacet;
      var option = options.find(function (option) { return option.group === group && option.value === input.value; });
      if (!option) return;
      input.checked = selected[group].indexOf(input.value) !== -1;
      var candidate = Object.assign({}, selected);
      candidate[group] = [input.value];
      var count = products.filter(function (product) { return matches(product, candidate); }).length;
      var row = input.closest('li');
      row.querySelectorAll('.facet-checkbox__text').forEach(function (node) {
        var label = node.querySelector('.facet-checkbox__text-label');
        if (!label) return;
        var badge = node.querySelector('[data-serene-count]');
        if (!badge) {
          Array.from(node.childNodes).forEach(function (child) { if (child.nodeType === 3) child.textContent = ''; });
          badge = document.createElement('span');
          badge.dataset.sereneCount = '';
          node.append(' ', badge);
        }
        badge.textContent = '(' + count + ')';
      });
      var accessible = row.querySelector('.visually-hidden');
      if (accessible) accessible.textContent = option.label + ' (' + count + ' products)';
    });
    activeContainers.forEach(function (container) {
      var chips = container.querySelector('.serene-active-filters');
      chips.replaceChildren();
      groups.forEach(function (group) {
        selected[group].forEach(function (value) {
          var option = options.find(function (option) { return option.group === group && option.value === value; });
          var chip = document.createElement('button');
          chip.type = 'button';
          chip.className = 'active-facets__button active-facets__button--light';
          chip.textContent = option.label + ' ×';
          chip.setAttribute('aria-label', 'Remove ' + option.label);
          chip.addEventListener('click', function () { selected[group] = selected[group].filter(function (item) { return item !== value; }); changeUrl(); render(); });
          chips.appendChild(chip);
        });
      });
    });
    scope.querySelectorAll('.js-filter').forEach(function (details) {
      var summary = details.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', String(details.open));
    });
  }
  scope.addEventListener('submit', function (event) {
    if (event.target.closest('facet-filters-form')) event.preventDefault();
  }, true);
  scope.addEventListener('change', function (event) {
    var input = event.target;
    if (input.matches('input[data-serene-facet]')) {
      event.stopImmediatePropagation();
      var group = input.dataset.sereneFacet;
      var values = selected[group].filter(function (value) { return value !== input.value; });
      if (input.checked) values.push(input.value);
      selected[group] = values;
      changeUrl();
      render();
    } else if (input.matches('select[name="sort_by"]')) {
      event.stopImmediatePropagation();
      // Shopify applies every native sort across the complete collection, including
      // best-selling/date sorts whose authoritative ranking is not in the DOM.
      var url = currentUrl();
      url.searchParams.set('sort_by', input.value);
      location.assign(url.pathname + url.search);
    }
  }, true);
  scope.querySelectorAll('select[name="sort_by"]').forEach(function (select) { select.value = nativeSort; });
  scope.querySelectorAll('facet-remove a').forEach(function (link) {
    link.href = location.pathname;
    link.addEventListener('click', function (event) { event.preventDefault(); event.stopImmediatePropagation(); groups.forEach(function (group) { selected[group] = []; }); changeUrl(); render(); }, true);
  });
  scope.querySelectorAll('.mobile-facets__footer button').forEach(function (button) {
    button.addEventListener('click', function (event) { event.preventDefault(); event.stopImmediatePropagation(); closeMobile(); }, true);
  });
  scope.querySelectorAll('.mobile-facets__disclosure, .mobile-facets__details').forEach(function (details) { details.addEventListener('toggle', function () { details.classList.toggle('menu-opening', details.open); if (!details.open) details.querySelectorAll('details').forEach(function (child) { child.open = false; child.classList.remove('menu-opening'); }); }); });
  scope.querySelectorAll('.mobile-facets__close-button').forEach(function (button) {
    button.addEventListener('click', function (event) { event.preventDefault(); var details = button.closest('details'); if (details) { details.open = false; details.classList.remove('menu-opening'); } }, true);
  });
  scope.querySelector('.mobile-facets__close')?.addEventListener('click', function (event) { event.preventDefault(); closeMobile(); });
  scope.querySelectorAll('.button-show-more').forEach(function (button) {
    button.addEventListener('click', function (event) {
      event.preventDefault();
      var expanded = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!expanded));
      button.closest('details').querySelectorAll('.show-more-item').forEach(function (row) { row.classList.toggle('hidden', expanded); });
    });
  });
  addEventListener('popstate', function () { readSelection(); render(); });
  readSelection();
  render();
})();
